<template>
	<v-container style="padding: 0; z-index: 10000;">
		<v-dialog title="当日排课明细" v-model="hideShow" width="1000px" persistent>
			<v-card>
				<v-card-title>
					<span>{{classDate}}课表</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-data-table :headers="data.headers" v-model="selectedItems" :items="data.list" :loading="query.loading" class="elevation-1 mt-5"
						disable-pagination hide-default-footer item-key="id" show-select loading-text="正在加载,请稍候......" no-data-text="暂无数据">
						<template v-slot:top>
							<v-row dense class="mb-n5">
								<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
									<div style="width: 150px;" class="mr-1">
										<v-select :items="statusItems" v-model="query.status" item-text="statusName"
											item-value="id" label="状态" dense outlined></v-select>
									</div>
									<v-btn @click="getDataList" color="info">查询</v-btn>
									<v-spacer></v-spacer>
									<v-btn color="info" :loading="batchDelay.submiting" class="mr-5" @click="submitBatchDelay">批量顺延</v-btn>
								</v-col>
							</v-row>
							<v-divider></v-divider>
						</template>
						<template v-slot:item.courseName="{item}">
							<span>{{ item.courseName }}</span>
							<template v-if="item.isAllowBook=='1'">
								<v-chip small color="success" outlined class="ml-2 mt-n1">约</v-chip>
							</template>
						</template>
						<template v-slot:item.weekAt="{item}">
							{{ weekName(item.weekAt) }}
						</template>
						<template v-slot:item.timeRange="{item}">
							{{item.timeFrom}}-{{item.timeTo}}
						</template>
						<template v-slot:item.status="{item}">
							
							<span v-if="item.status =='1'"  style="color:#FF9100">待核销</span>
							<span v-if="item.status =='2'" >已核销</span>
							<span v-if="item.status =='3'" style="color:#43A047;">已顺延</span>
					
						</template>
						
						<template v-slot:item.action="{item}">
							<v-btn small color="info" @click="showRecordView(item)">详情</v-btn>
						</template>
					
					</v-data-table>
					<div class="pt-2">
						<v-row dense>
							<v-col cols="2" >
								<v-select :items="[10, 20, 50, 100]" @change="handleSizeChanged" dense hide-details label="每页数量"
									outlined v-model="query.size" />
							</v-col>
							<v-col cols="1" class="mt-2">
								<span>共{{data.total}}项</span>
							</v-col>
							<v-col cols="9" v-if="Math.ceil(data.total/query.size)>0">
								<v-pagination :length="Math.ceil(data.total/query.size)" @input="handlePageChanged"
									total-visible="5" v-model="query.page" />
							</v-col>
						</v-row>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
		
		<!-- 课次详情 -->
		<recordInfoView :show="recordView.show" :recordId="recordView.recordId" @cancel="recordView.show=false"></recordInfoView>		
	</v-container>
</template>

<script>
	import global from "../config/global"
	import utils from "../config/utils"
	import recordInfoView from "./record_info_view.vue"
	export default {
		name:"class-record-list",
		components:{
			recordInfoView
		},
		props:{
			show:{
				type:Boolean,
				default:false
			},
			classDate:{
				type:String,
				default:""
			}
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					this.data.list=[];
					this.selectedItems = [];
					this.getDataList();
				}
			},
		},
		data(){
			return {
				shopId:"",
				hideShow:this.show,
				statusItems:[
					{id:"",statusName:"全部"},
					{id:"1",statusName:"待核销"},
					{id:"2",statusName:"已核销"},
					{id:"3",statusName:"已顺延"},
				],
				selectedItems:[],
				weekItems:global.weekList,
				query:{
					loading:false,
					page:1,
					size:10,
					status:""
				},
				data: {
					total:0,
					headers:[
						{
							text: '课程',
							value: 'courseName',
							sortable: false
						},
						{
							text: '班级',
							value: 'className',
							sortable: false
						},
						{
							text: '老师',
							value: 'teacherName',
							sortable: false
						},
						{
							text: '时间段',
							value: 'timeRange',
							sortable: false
						},
						
						{
							text: '教室',
							value: 'roomName',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '操作',
							value: 'action',
							sortable: false
						},
					],
					list:[],
					
				},
				recordView:{
					show:false,
					recordId:""
				},
				batchDelay:{
					submitting:false
				}
				
			}
		},
		mounted() {
			console.log("day-record-list mounted");
			this.shopId = utils.getCurrentShopId();
			this.getDataList();
		
		},
		methods:{
			handleSizeChanged(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getDataList();
			},
			handlePageChanged(page) {
				this.query.page = page;
				this.getDataList();
			},
			weekName(wk) {
			
				let stName = "未知";
				this.weekItems.forEach((item,index)=>{
					if (item.week == wk){
						stName = item.weekName;
					}
				})
				return stName;
			},
			getDataList(){
				const that = this;
				const classId = this.classId;
				let url = `/edu/class/record/list/by/date/${this.classDate}/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if(this.shopId){
					url += "&shopId="+this.shopId;
				}
				if(this.query.status){
					url += "&status="+this.query.status;
				}
							
				this.axios.get(url).then(response => {
							
					if (response.data["code"] === 200) {
						
						console.log(response.data);
						
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
						return
					}
				})
			},
			cancel(){
				this.$emit("cancel","")
			},
			showRecordView(item){
				this.recordView.recordId = item.id;
				this.recordView.show = true;
			},
			submitBatchDelay(){
				//批量顺延
				if (this.selectedItems.length == 0){
					this.$noty.error('没有选中的数据');
					return
				}
				let ids = [];
				this.selectedItems.forEach((item,index)=>{
					ids.push(item.id);
				});
				
				this.batchDelay.submitting = true;
				// api
				const that = this;
				let url = `/edu/class/record/batch/delay`;
				
				let postData = {};
				postData.ids = ids;
				
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getDataList();
							that.batchDelay.submitting = false;
							that.selectedItems = [];
							return;
						} else {
							that.batchDelay.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.batchDelay.submitting = false;
						that.$noty.error('网络请求失败');
					}
				});
			},
		}
	}
	
</script>


<style>
</style>
